export default __webpack_public_path__ + "media/images/images_v2/bottomright-onglet-287427b5680e1a1f8e69d94648fa5c65.png";